/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_What_P4Inputs */

const en_wc_what_p4 = /** @type {(inputs: Wc_What_P4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft is developed by ArtCraft. This site is an independent guide and hosts the browser build. The Microsoft Word comparison covers file compatibility, offline use and collaboration, so you can assess whether the editor suits your work. Keep copies of important files while testing the alpha release.`)
};

/**
* | output |
* | --- |
* | "WordCraft is developed by ArtCraft. This site is an independent guide and hosts the browser build. The Microsoft Word comparison covers file compatibility, o..." |
*
* @param {Wc_What_P4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_what_p4 = /** @type {((inputs?: Wc_What_P4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_What_P4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_what_p4(inputs)
});
export { wc_what_p4 as "wc.what.p4" }